/**
 * BulkUploadToolbar — action bar for BulkImageUpload (counts, AI buttons, save).
 */
import { Button } from "@/components/ui/button";
import { Upload, Check, Loader2, Sparkles, FileText } from "lucide-react";

export function BulkUploadToolbar({
  pendingCount,
  productsWithoutImage,
  generating,
  genMode,
  genProgress,
  saving,
  onGenerateWithAI,
  onGenerateDescriptions,
  onMultiFileSelect,
  onSaveAll,
}) {
  return (
    <div className="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-3 mb-2 gap-2 flex-wrap">
      <div className="text-sm text-gray-600">
        <span className="font-bold text-emerald-700">{pendingCount}</span> listas |{" "}
        <span className="font-bold text-gray-500">{productsWithoutImage}</span> sin foto
      </div>
      <div className="flex gap-2 flex-wrap">
        <Button
          onClick={onGenerateWithAI}
          disabled={generating || productsWithoutImage === 0}
          variant="outline"
          className="gap-1.5 border-purple-200 text-purple-700 hover:bg-purple-50"
          data-testid="bulk-ai-generate-btn"
        >
          {generating && genMode !== "desc" ? (
            <>
              <Loader2 className="w-3.5 h-3.5 animate-spin" />
              Fotos {genProgress.current}/{genProgress.total}
            </>
          ) : (
            <>
              <Sparkles className="w-3.5 h-3.5" />
              Fotos IA ({productsWithoutImage})
            </>
          )}
        </Button>
        <Button
          onClick={onGenerateDescriptions}
          disabled={generating}
          variant="outline"
          className="gap-1.5 border-blue-200 text-blue-700 hover:bg-blue-50"
          data-testid="bulk-ai-desc-btn"
        >
          {generating && genMode === "desc" ? (
            <>
              <Loader2 className="w-3.5 h-3.5 animate-spin" />
              Desc {genProgress.current}/{genProgress.total}
            </>
          ) : (
            <>
              <FileText className="w-3.5 h-3.5" />
              Descripciones IA
            </>
          )}
        </Button>
        <label className="cursor-pointer">
          <input
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={e => e.target.files?.length && onMultiFileSelect(e.target.files)}
            data-testid="bulk-file-input"
          />
          <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium hover:bg-gray-50 transition cursor-pointer">
            <Upload className="w-3.5 h-3.5" /> Subir fotos
          </span>
        </label>
        <Button
          onClick={onSaveAll}
          disabled={pendingCount === 0 || saving}
          className="bg-emerald-600 hover:bg-emerald-700 text-white gap-1.5"
          data-testid="bulk-save-btn"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
          Guardar ({pendingCount})
        </Button>
      </div>
    </div>
  );
}
